/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Goto_UserInputs */

const en_admin_statistics_goto_user = /** @type {(inputs: Admin_Statistics_Goto_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to user`)
};

const de_admin_statistics_goto_user = /** @type {(inputs: Admin_Statistics_Goto_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Benutzerprofil`)
};

/**
* | output |
* | --- |
* | "Go to user" |
*
* @param {Admin_Statistics_Goto_UserInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_goto_user = /** @type {((inputs?: Admin_Statistics_Goto_UserInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Goto_UserInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_goto_user(inputs)
	return en_admin_statistics_goto_user(inputs)
});